import {
  Actions,
  createMapper,
  Getters,
  Module,
  Mutations,
} from 'vuex-smart-module'
import { Vue } from 'vue-property-decorator'
import _ from 'lodash'

import UserAPI from '@/components/routes/auth/auth-page/helpers/requests/user'
import { roles } from '@/config/roles'
import { User } from 'interfaces/user'
import InfoAPI, { BuildInfo } from '@/api/info'
import * as Sentry from '@sentry/vue'

class UserState {
  user?: User | null
  clientVersion: BuildInfo | null = null
}

class UserGetters extends Getters<UserState> {
  get isAuthenticated() {
    return !_.isNil(this.state.user)
  }

  get currentUser() {
    return this.state.user
  }

  get userRoles() {
    return this.state.user?.roles ?? []
  }

  get educations() {
    return this.state.user?.educations ?? []
  }

  get isAdmin() {
    return this.getters.userRoles.includes(roles.admin)
  }

  get isListener() {
    return this.getters.userRoles.includes(roles.listener)
  }

  get isAdminProgram() {
    return this.getters.userRoles.includes(roles.adminProgram)
  }

  get isFakeAuth() {
    return !!this.state.user?.actualUser
  }
}

class UserMutations extends Mutations<UserState> {
  setUser(user: User | null) {
    Vue.set(this.state, 'user', user)
    if (user) {
      Sentry.setUser({
        email: user.email,
        id: String(user.id),
        name: user.name,
        surname: user.surname,
        midname: user.midname,
      })
    } else {
      Sentry.setUser(null)
    }
  }
  setClientVersion(data: BuildInfo | null) {
    this.state.clientVersion = data
  }
}

class UserActions extends Actions<
  UserState,
  UserGetters,
  UserMutations,
  UserActions
> {
  async fetchCurrentUser(reload = false) {
    try {
      const [user, client] = await Promise.all([
        UserAPI.getCurrentUser(reload),
        InfoAPI.getClientBuildFromServer(),
      ])
      this.mutations.setClientVersion(client.data)
      this.mutations.setUser(user.data.user)
    } catch (err) {
      this.mutations.setUser(null)
    }
  }
}

export const user = new Module({
  state: UserState,
  getters: UserGetters,
  mutations: UserMutations,
  actions: UserActions,
})

export const userMappers = createMapper(user)
